export default __webpack_public_path__ + "static/pic01-2d0f9d36cc04d0ad75a6ef7ad27547b8.jpg";